import * as maps from 'google-maps-react'
import WCC from 'wcc'

const connectGoogleMaps = maps.GoogleApiWrapper({
  apiKey: WCC.WMR_CONSTANTS.GOOGLE_MAPS_API_KEY,
  libraries: ['places', 'geometry'],
})

export default connectGoogleMaps
